import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const VoltPaymentGatewayIframe = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  const {
    url,
  } = state || {};

  useEffect(() => {
    const interval = setInterval(() => {
      const currentSrc = iframeRef.current?.src;
      if (!currentSrc) return;

      console.log("Checking iframe srccccc:", currentSrc);
      
      if (currentSrc.includes("paymentStatus=COMPLETED")) {
        toast.success("Payment Successful");
        clearInterval(interval);
        navigate("/");
      } else if (currentSrc.includes("paymentStatus=FAILED")) {
        toast.error("Payment Failed");
        clearInterval(interval);
        navigate("/");
      } else if (currentSrc.includes("paymentStatus=PENDING")) {
        toast.info("Payment in pending");
        clearInterval(interval);
        navigate("/");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  //   const currentSrc = iframeRef.current?.src;
  //   console.log('currentSrc',currentSrc);
  //   if (!currentSrc) return;

  //   if (currentSrc.includes("https://login.fxmaster.co.uk/voltsuccess")) {
  //     console.log('success screen');
  //     toast.success("Payment Successful");
  //     navigate("PaymentSuccess");
  //   } else if (currentSrc.includes("https://login.fxmaster.co.uk/voltfailed")) {
  //     console.log('failed screen');
  //     toast.error("Payment Failed");
  //     navigate("/Dashboard");
  //   } else if (currentSrc.includes("https://login.fxmaster.co.uk/voltcancelled")) {
  //     console.log('success screen');
  //     console.log('cancel  screen');
  //     toast.info("Payment Cancelled by the user");
  //     navigate("/SendMoney");
  //   }
  // };


  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <header style={{ background: "#004aad", color: "white", padding: "1rem", textAlign: "center" }}>
        <h2>Secure Payment</h2>
      </header>

      <main style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <iframe
          ref={iframeRef}
          src={url}
          title="Volt Checkout"
          style={{
            width: "90%",
            height: "80%",
            border: "none",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        />
      </main>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </div>
  );
};

export default VoltPaymentGatewayIframe;


